namespace GeniuzPOS.Administration {
    export class PsBizTypesColumns {
        static columnsKey = 'Administration.PsBizTypes';
    }
}
